import cn from 'classnames';

import { ButtonProps } from '@yandex-360/orb-components/dist/components/Button';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { Picture } from '../Picture';

import css from './MediaBlock.module.css';

export type ImageProps = string[];

type ImageMedia = { image: ImageProps }

type Media = ImageMedia;

export type MediaBlockProps = {
    textProps: {
        title: string;
        subTitle: string;
        buttons: ButtonProps[];
    };
    media: Media;
    className?: string;
    direction?: 'media-content' | 'content-media' | 'large-media';
    mobileDirection?: 'media-content' | 'content-media';
    bg?: 'transparent' | 'accent' | 'white' | 'grey' | 'primary' | 'light';
};

export const MediaBlock = ({
    className,
    textProps,
    media,
    direction = 'content-media',
    mobileDirection = 'media-content',
    bg = 'transparent',
}: MediaBlockProps) => {
    const isImage = (media: Media): media is ImageMedia => 'image' in media;

    const renderMedia = (media: Media, className?: string) => (
        <div className={cn(css.media, className)}>
            { isImage(media) &&
                <Picture imageClassName={css.pictureImg} images={media.image} alt={textProps.title} /> }
        </div>
    );

    return (
        <div
            className={cn(
                css.container,
                mobileDirection === 'content-media' && css.contentMediaMobile,
                css.padding,
                css[direction],
                css[bg],
                className,
            )}
        >
            <div className={css.textWrapper}>
                <Text typography='heading-md' as='h2' className={css.title}>
                    {textProps.title}
                </Text>
                <Text typography='body-md-regular' as='p' color='secondary'>
                    {textProps.subTitle}
                </Text>
                <div className={css.buttons}>
                    {textProps.buttons.map(button => (
                        <Button {...button} />
                    ))}
                </div>
            </div>

            {renderMedia(media)}
        </div>
    );
};
